// NOTE: Remove all non-digits, minus if it's not at the start and 0 if it's at the start
export const formatStringValue = (value: string, isDecimalAllowed = false) => {
  let result = value
  if (!isDecimalAllowed) {
    result = value.replace(/(?<!^)-|[^-0-9]|^0+(?=\d)/g, '')
  } else {
    result = value
      .replace(/,/g, '.')
      .replace(/(?<!^)-|[^0-9.-]|(?<=\..*)\.|(?<=^0)0+(?=\d)/g, '')

    const [intPart, decimalPart] = result.split('.')
    if (decimalPart !== undefined) {
      result = `${intPart}.${decimalPart.slice(0, 1)}`
    }
  }

  return result
}

export const isEmptyOrMinus = (value: string) => ['', '-'].includes(value)

export const clampValueToMinMaxRange = (
  value: number,
  min: number,
  max: number,
) => {
  if (value < min) {
    return min
  }
  if (value > max) {
    return max
  }
  return value
}

export const convertNumberValueToStringValue = (
  numberValue: number | null | undefined,
) => {
  if (typeof numberValue !== 'number' || Number.isNaN(numberValue)) {
    return ''
  }
  return numberValue.toString()
}
